import React from "react";
import { AreaChart, Area, Tooltip, ResponsiveContainer } from "recharts";
import { formatCurrency } from "../utils/format";

const SparklineTooltip = ({ active, payload }) => {
  if (!active || !payload || !payload.length) return null;

  const point = payload[0].payload;

  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-md px-3 py-2 text-sm whitespace-nowrap">
      <p className="text-xs text-slate-500 font-medium">{point.fullLabel || point.label}</p>
      <p className="text-slate-900 font-semibold mt-0.5 tabular-nums">{formatCurrency(point.value)}</p>
    </div>
  );
};

const MiniSparkline = ({ data, color = "#0E7A3E", gradientId = "sparklineFill" }) => (
  <ResponsiveContainer width="100%" height="100%">
    <AreaChart data={data} margin={{ top: 2, right: 0, left: 0, bottom: 0 }}>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity={0.35} />
          <stop offset="100%" stopColor={color} stopOpacity={0} />
        </linearGradient>
      </defs>
      <Tooltip content={<SparklineTooltip />} cursor={{ stroke: color, strokeWidth: 1, strokeOpacity: 0.4 }} />
      <Area
        type="monotone"
        dataKey="value"
        stroke={color}
        strokeWidth={1.75}
        fill={`url(#${gradientId})`}
        dot={false}
        activeDot={{ r: 3.5, fill: color, stroke: "#fff", strokeWidth: 1.5 }}
        isAnimationActive={false}
      />
    </AreaChart>
  </ResponsiveContainer>
);

export default MiniSparkline;
